var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnquireFrom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.33301,
    y: 40.4446,
    width: 39.1111,
    height: 3.55556,
    fill: "#20566B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8887 12H33.222V40.4444H11.8887V12ZM17.222 17.3334H27.8887V20.889H17.222V17.3334ZM27.8886 24.4444H17.2219V28H27.8886V24.4444Z",
    fill: "#20566B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7773,
    y: 22.6665,
    width: 7.11111,
    height: 17.7778,
    fill: "#20566B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquireFrom1);
export default __webpack_public_path__ + "static/media/enquireFrom1.56b7090f483aae0caae3c35e7d6c2fa9.svg";
export { ForwardRef as ReactComponent };